module.exports = __webpack_public_path__ + "static/media/ChevronUp.88365989.svg";